module.exports = __webpack_public_path__ + "img/Raggam Helmut.jpg";